import { Button, List } from 'antd';
import React, { useCallback, useEffect, useReducer, useState } from 'react';
import { NumberParam } from 'use-query-params';
import useSearchParam from '../../hooks/useQueryParams';

interface Props<T> {
  isLoading:boolean;
  data: T[] | null;
  total: number;
  render: (T:T) => JSX.Element;
  lastPage: number;
  loadMoreText: string | JSX.Element;
}

function CustomList<T>({isLoading, data, lastPage, render, total, loadMoreText }:Props<T> ){
  const [lastData, setLastData] = useState([]);
  const [page, setPage] = useSearchParam<number, any>('page', NumberParam);

  useEffect(() => {
    if(!data.length) return;
    if(isLoading) return;
    setLastData(prev => prev.concat(data))
  },[data, data.length, isLoading])


  const loadMore =
    !isLoading && (lastData.length !== total || page !== lastPage) ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
        }}
      >
        <Button onClick={()=>setPage(prev => prev + 1)}>{loadMoreText || "Buscar mais"}</Button>
    </div>
  ) : null;

  return ( 
    <List
      className="demo-loadmore-list"
      loading={isLoading}
      itemLayout="horizontal"
      loadMore={loadMore}
      rowKey={'id'}
      >
        {lastData?.map(item=> render(item))}
      </List>
  )
}

export default CustomList;